import u from "lodash";
import e from "react";
import { u as T } from "./ThemeProvider--i7ESlT5.es.js";
import { u as L } from "./DarkModeProvider-xoZXm3ct.es.js";
import { c as x, d as i, T as g } from "./index-Dd-4N6BE.es.js";
import { I as y } from "./Icon-BuIPTPJn.es.js";
import './Link.css';const E = "Link-module__cardLink___debSo", b = "Link-module__linkText___1bzp7", l = {
  cardLink: E,
  linkText: b
}, S = {
  default: i,
  compere: x
}, v = ({
  children: m,
  onClick: t,
  iconName: c = "open_tab",
  openInNewTab: p = !1,
  darkBg: o = !1,
  href: n = void 0
}) => {
  const f = T(), a = u.get(S, f, i), _ = L(), d = /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("span", { className: l.linkText }, m), /* @__PURE__ */ e.createElement(
    y,
    {
      name: c,
      color: o || _ ? a.darkLinkColor : a.lightLinkColor,
      size: 20,
      style: { verticalAlign: "bottom" }
    }
  )), k = p ? "_blank" : "_self";
  let r = typeof t == "string" ? t : "";
  return n && (r = n), /* @__PURE__ */ e.createElement("span", { className: l.cardLink }, /* @__PURE__ */ e.createElement(g.Heading5, { responsive: !0, darkBg: o }, /* @__PURE__ */ e.createElement(
    "a",
    {
      href: r,
      target: k,
      onClick: (s) => {
        s.stopPropagation(), typeof t == "function" && (t(), n || s.preventDefault());
      }
    },
    d
  )));
};
v.displayName = "Link";
export {
  v as L
};
